import { render } from "./GradeGroupList.vue?vue&type=template&id=044b8724"
import script from "./GradeGroupList.vue?vue&type=script&lang=js"
export * from "./GradeGroupList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__